// © Microsoft Corporation. All rights reserved.

import { ElementStyles, css } from "@microsoft/fast-element";

export const MarketSelectorStyles: ElementStyles = css`
:host {
    display: flex;
    flex-direction: column;
    min-width: 200px;
    font-size: var(--type-ramp-base-font-size);
    line-height: var(--type-ramp-base-line-height);
}

.select {
    height: 32px;
    margin-top: 10px;
    margin-bottom: 8px;
    max-width: 374px;
}

.select::part(listbox) {
    --max-height: 336px;
    height: 336px;
}

.selector-icon {
    height: 16px;
    width: 16px;
}
`.withBehaviors();
